import './calendar.less';
import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';
import isEqual from 'lodash/isEqual';
import { DateRange } from 'react-date-range';
import moment from 'moment';

import theme from './calendar-theme-rewrite';
import Toggle from '../toggle';

class Calendar extends React.Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		if (this.props.onInit) {
			this.props.onInit();
		}
	}

	shouldComponentUpdate(nextProps) {
		const isOpenStatusEqual = isEqual(this.props.isOpen, nextProps.isOpen);
		const isDateRangeEqual = isEqual(this.props.dateRange, nextProps.dateRange);

		if (isOpenStatusEqual && isDateRangeEqual) {
			return false;
		}

		return true;
	}

	render() {
		return (
			<div className={cn('calendar-wrap', this.props.className)}>
				<Toggle
					head={
						<div
							className={cn('calendar-wrap__head', this.props.isOpen && 'is-open')}
							onClick={ e => this.props.onToggle() }>
							<span className="selected-value">{ this.props.dateRange ? this.props.dateRange.join(' - ') : '' }</span>
						</div>
					}
					isShow={this.props.isOpen}
					onOutSideClick={e => this.props.onToggle()}>
					<div className="calendar-wrap__body">
						<DateRange
							ranges={this.props.ranges}
							startDate={this.props.startDate}
							endDate={this.props.endDate}
							onChange={ (date, selectedContextFunction) => {
								this.props.onChange(date, this.props.onApply);

								// Plugin doesn't have method for detect click source ( PredefinedRanges or Calendar )
								// I detect use defaultProps length
								const propsNameList = Object.keys(selectedContextFunction.defaultProps);
								if (propsNameList.length === 2) {
									this.props.onApply();
								}
							}}
							theme={theme}
							maxDate={this.props.maxDate || (this.props.isMaxDateDisabled ? undefined : moment())}
						/>
					</div>
				</Toggle>
			</div>
		);
	}
}

Calendar.propTypes = {
	onToggle: PropTypes.func,
	onChange: PropTypes.func,
	onApply: PropTypes.func,
	onInit: PropTypes.func,
	onApplyDefaultValues: PropTypes.func,
	componentName: PropTypes.string,
	dateRange: PropTypes.array,
	isOpen: PropTypes.bool,
	ranges: PropTypes.object,
	startDate: PropTypes.object,
	endDate: PropTypes.object,
	intl: PropTypes.func
};

export default Calendar;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/calendar/main.js